// extracted by mini-css-extract-plugin
export default {"root":"_3Zzs5","normal":"_3x1Nw","small":"_223NH"};